import { IScore, IUserDashboard } from 'models/score.model'
import type { IUserDashboardV2 } from 'models/score.model'
import api from './api'
import { AxiosResponse } from 'axios'
import { resolveActiveCompanyId } from 'util/superAdmin'

const getScoreV2 = async (): Promise<IScore> => {
  const companyId = resolveActiveCompanyId()

  const { data } = await api.get<IScore>(`/v2/company/${companyId}/score`)
  return data
}

const getCompanyScoreV2 = async (): Promise<IScore> => {
  const companyId = resolveActiveCompanyId()

  const { data } = await api.get<IScore>(`/v1/score/company/${companyId}`)
  return data
}

const scanAgain = (email: string): Promise<AxiosResponse> => {
  return api.post(`/v1/scan/${email}`)
}

const getUserDashboardData = async (cognitoId: string): Promise<IUserDashboard> => {
  const { data } = await api.get<IUserDashboard>(`/v2/user/${cognitoId}/dashboard`)
  return data
}

export const getUserDashboardDataV2 = async (cognitoId: string): Promise<IUserDashboardV2> => {
  const { data } = await api.get<IUserDashboardV2>(`/v2/user/${cognitoId}/dashboard/v2`)
  return data
}

export default {
  getScoreV2,
  getCompanyScoreV2,
  scanAgain,
  getUserDashboardData,
  getUserDashboardDataV2,
}
